import { useEffect } from "react";

export default function InstagramSection() {

  useEffect(() => {
    if (window.instgrm) {
      window.instgrm.Embeds.process();
    }
  }, []);

  return (
    <section id="instagram" className="instagram-section">

      <div className="sec-label">Follow Us on Instagram</div>
      <h2 className="sec-title">
        Moments we’ve <em>crafted.</em>
      </h2>

      <div className="instagram-wrapper">
        <div className="instagram-frame">

  <div className="insta-card">
    <blockquote
      className="instagram-media"
      data-instgrm-permalink="https://www.instagram.com/p/DVXifonkr96/"
      data-instgrm-version="14"
    ></blockquote>
  </div>

  <div className="insta-card">
    <blockquote
      className="instagram-media"
      data-instgrm-permalink="https://www.instagram.com/reel/DVtxSQEkqMS/"
      data-instgrm-version="14"
    ></blockquote>
  </div>

  <div className="insta-card">
    <blockquote
      className="instagram-media"
      data-instgrm-permalink="https://www.instagram.com/reel/DV0jG1GD_-r/"
      data-instgrm-version="14"
    ></blockquote>
  </div>

</div>
      </div>

    </section>
  );
}